import { AxiosRequestConfig } from 'axios'
import {
  Notification as Data,
  NotificationCollection as Collection,
} from '@/typings/api/Notification'
import {
  BaseApiParams as BP,
  BaseApiResponseCollection as BRC,
  CollectionMeta,
} from '@/typings/common'

import { BaseLkApiAuth } from '@/api/BaseApiAuth'


interface NotificationsCollectionMeta extends CollectionMeta {
  unread_count?: number;
}

export class NotificationsApi extends BaseLkApiAuth<Data, Collection, BP> {
  protected readonly endpoint = 'notifications';

  public getNotifications(data?: BP, config?: AxiosRequestConfig) {
    const path = ''
    const [url, params] = this.getUrl(path, data)
    return this.request<null, BRC<Collection, NotificationsCollectionMeta>>(
      'GET', url, { params, ...config },
    )
  }

  public getCount(params: BP, config?: AxiosRequestConfig) {
    return this.getNotifications(params, config)
  }

  public readNotifications(data: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = 'read/'
    const [url] = this.getUrl(path, data)
    return this.request('POST', url, { data, ...config })
  }

  public readAllNotifications(data: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = 'read/all/'
    const [url] = this.getUrl(path, data)
    return this.request('POST', url, { data, ...config })
  }
}
